import { Stack, Typography } from "@mui/material"
import { updateMacroLinked } from "authoring/routes/macro/controller/update-macro-linked"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { EditRecord } from "lib/@components/edit-record"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { MacroUpdated } from "../macro-events"
import { LinkedMacrosInner } from "./linked-macros-inner"
import { MacroLinkedView } from "./macro-linked-view"

export function LinkedMacrosEditor({ macro, macros = [], editMode = true }) {
    if (!macro) return null

    return (
        <Stack spacing={1.25} data-cy="macro-linked-section">
            <Typography variant="subtitle2">Linked macros</Typography>
            <If truthy={editMode}>
                <EditRecord key={macro.id} target={macro} store={saveLinked} debounceTime={500}>
                    <LinkedMacrosInner macros={macros} editMode={editMode} />
                </EditRecord>
                <Else>
                    <MacroLinkedView linked={macro?.linked ?? []} macros={macros} />
                </Else>
            </If>
        </Stack>
    )

    async function saveLinked({ linked }) {
        try {
            await updateMacroLinked({ id: macro.id, linked })
            MacroUpdated.raise({ id: macro.id, linked })
        } catch (error) {
            errorSnackbar(error?.message || "Failed to update linked macros")
        }
    }
}
